/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {Button, Card, CardBody, CardTitle, Col, Collapse, Container, Nav, NavItem, NavLink, Row,} from "reactstrap";
import NumberFormat from 'react-number-format';
import classnames from "classnames";
import CreditDataService from "../../services/CreditDataService";

class PointOfSalesHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dailyReport: {},
            isOpen: false,
        }
        this.creditDataService = new CreditDataService();
        this.toggleCollapse = this.toggleCollapse.bind(this); // Bind the method
    }

    componentDidMount() {
        this.creditDataService.getDailyReport()
            .then((res) => {
                this.setState({
                    dailyReport: res.data,
                })
            })
    }

    toggleCollapse = () => {
        this.setState({isOpen: !this.state.isOpen});
    };

    render() {
        return (
            <>
                <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
                    <Container fluid>
                        <div className="header-body mx-3 mb-3">
                            <Row>
                                <Col lg="12" xl="12">
                                    <div className="ml-n3 d-flex align-items-center">
                                        <Button
                                            color="primary"
                                            href="#pablo"
                                            onClick={() => this.toggleCollapse()}
                                            size="sm"
                                        >
                                            <i className="fas fa-caret-down" />
                                        </Button>
                                        <h3 className="mb-0">Total Summary</h3>
                                    </div>
                                </Col>
                                <Col lg="6" xl="3" className="mt-4">
                                    <Collapse isOpen={this.state.isOpen}>
                                        <Card className="card-stats mb-4 mb-xl-0 ml-n3">
                                            <CardBody>
                                                <Row>
                                                    <div className="col">
                                                        <CardTitle
                                                            tag="h5"
                                                            className="text-uppercase text-muted mb-0"
                                                        >
                                                            Total cashbon
                                                        </CardTitle>
                                                        <span className="h2 font-weight-bold mb-0">
                                                          <NumberFormat
                                                              value={this.state.dailyReport.cashbon_total}
                                                              displayType={'text'}
                                                              thousandSeparator={true}
                                                              prefix={'Rp.'}
                                                              suffix={',00'}/>
                                                        </span>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </Col>
                                <Col lg="6" xl="3" className="mt-4">
                                    <Collapse isOpen={this.state.isOpen}>
                                        <Card className="card-stats mb-4 mb-xl-0">
                                            <CardBody>
                                                <Row>
                                                    <div className="col">
                                                        <CardTitle
                                                            tag="h5"
                                                            className="text-uppercase text-muted mb-0"
                                                        >
                                                            Total cash
                                                        </CardTitle>
                                                        <span className="h2 font-weight-bold mb-0">
                                                          <NumberFormat
                                                              value={this.state.dailyReport.cash_total}
                                                              displayType={'text'}
                                                              thousandSeparator={true}
                                                              prefix={'Rp.'}
                                                              suffix={',00'}/>
                                                          </span>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </Col>
                                <Col lg="6" xl="3" className="mt-4">
                                    <Collapse isOpen={this.state.isOpen}>
                                        <Card className="card-stats mb-4 mb-xl-0">
                                            <CardBody>
                                                <Row>
                                                    <div className="col">
                                                        <CardTitle
                                                            tag="h5"
                                                            className="text-uppercase text-muted mb-0"
                                                        >
                                                            Total diskon
                                                        </CardTitle>
                                                        <span className="h2 font-weight-bold mb-0">
                                                          <NumberFormat
                                                              value={this.state.dailyReport.discount_total}
                                                              displayType={'text'}
                                                              thousandSeparator={true}
                                                              prefix={'Rp.'}
                                                              suffix={',00'}/>
                                                          </span>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </Col>
                                <Col lg="6" xl="3" className="mt-4">
                                    <Collapse isOpen={this.state.isOpen}>
                                        <Card className="card-stats mb-4 mb-xl-0">
                                            <CardBody>
                                                <Row>
                                                    <div className="col">
                                                        <CardTitle
                                                            tag="h5"
                                                            className="text-uppercase text-muted mb-0"
                                                        >
                                                            Total profit
                                                        </CardTitle>
                                                        <span className="h2 font-weight-bold mb-0">
                                                          <NumberFormat
                                                              value={this.state.dailyReport.total_profit}
                                                              displayType={'text'}
                                                              thousandSeparator={true}
                                                              prefix={'Rp.'}
                                                              suffix={',00'}/>
                                                          </span>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </Col>
                            </Row>
                        </div>
                        <div className="header-body mx-3">
                            <Row>
                                <Nav
                                    className="nav-fill flex-column flex-md-row"
                                    id="tabs-icons-text"
                                    pills
                                    role="tablist"
                                >
                                    <NavItem>
                                        <NavLink
                                            aria-selected={this.props.tabs === 1}
                                            className={classnames("mb-sm-3 mb-md-0", {
                                                active: this.props.tabs === 1
                                            })}
                                            onClick={e => this.props.toggleNavs(e, "tabs", 1)}
                                            href="#pablo"
                                            role="tab"
                                        >
                                            Checkout belanjaan
                                        </NavLink>
                                    </NavItem>
                                    <NavItem lg="6">
                                        <NavLink
                                            aria-selected={this.props.tabs === 2}
                                            className={classnames("mb-sm-3 mb-md-0", {
                                                active: this.props.tabs === 2
                                            })}
                                            onClick={e => this.props.toggleNavs(e, "tabs", 2)}
                                            href="#pablo"
                                            role="tab"
                                        >
                                            Pengajuan kredit
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Row>
                        </div>
                    </Container>
                </div>
            </>
        );
    }
};

export default PointOfSalesHeader;
